import IconBase, { type IconProps } from '../IconBase';
const Svg24X24BellOutline = (props: Omit<IconProps, 'children'>) => {
  return (
    <IconBase data-testid="bellOutline" viewBox="0 0 24 24" {...props} width="24" height="24">
      <>
        <path
          fill="currentColor"
          d="M10 20a2 2 0 1 0 4 0zm.027-15.668a2 2 0 1 1 3.945 0A6 6 0 0 1 18 10v3l1.658 3.317A1.854 1.854 0 0 1 18 19H6a2 2 0 0 1-2-2l1.99-4L6 10a6 6 0 0 1 4.027-5.668M16 13.472V10a4 4 0 1 0-8 .007l-.012 3.466L6.234 17h11.53z"
        />
      </>
    </IconBase>
  );
};
export default Svg24X24BellOutline;
